import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "popup__container" }
const _hoisted_3 = { class: "popup__content" }
const _hoisted_4 = { class: "popup__header" }
const _hoisted_5 = { class: "h2-like" }
const _hoisted_6 = { class: "popup__block" }
const _hoisted_7 = {
  key: 0,
  class: "form__error-message"
}
const _hoisted_8 = { class: "form__submit" }
const _hoisted_9 = {
  class: "btn btn--fullscreen",
  type: "submit"
}

import { ref } from "vue"
import { useI18n } from "vue3-i18n"
import { notifyError, notifySuccess } from "@/notify"
import { Status } from "@/validation"
import FormInput from "@/components/forms/FormInput.vue"
import { useAccountingSoftwareCodeService } from "@/inversify.config"

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'AddAccountCodePopup',
  emits: ["closePopup", "codeCreated"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const { t } = useI18n()
const accountingSoftwareCodeService = useAccountingSoftwareCodeService()

const value = ref("")
const name = ref("")
const errorMessage = ref("")
const formInputs = ref<(typeof FormInput)[]>([])
const inputValidationStatuses: any = {}

function addFormInputRef(ref: typeof FormInput) {
  if (!formInputs.value.includes(ref))
    formInputs.value.push(ref)
}

async function handleValidation(fieldName: string, validationStatus: Status) {
  inputValidationStatuses[fieldName] = validationStatus.valid
}

async function handleSubmit() {
  formInputs.value.forEach((x: typeof FormInput) => x?.validateInput())

  if (Object.values(inputValidationStatuses).some(x => x === false)) {
    notifyError(t('global.formErrorNotification'))
    return
  }

  errorMessage.value = ""
  const created = await accountingSoftwareCodeService.createAccountCode(value.value, name.value)
  if (created?.value) {
    notifySuccess(t('products.form.accountingSoftwareConfiguration.codeAdded'))
    emit("codeCreated", { value: created.value, name: created.name ?? '' })
    closePopup()
    return
  }
  errorMessage.value = t('products.form.accountingSoftwareConfiguration.codeAlreadyExists')
}

function closePopup() {
  emit("closePopup")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "popup popup--visible",
    novalidate: "",
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    _createElementVNode("div", {
      class: "popup__bg",
      onClick: closePopup
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("products.form.accountingSoftwareConfiguration.addAccountCode")), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(FormInput, {
            modelValue: value.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
            ref: addFormInputRef,
            label: _unref(t)('products.form.accountingSoftwareConfiguration.accountCode'),
            name: "new-account-code-value",
            type: "number",
            onValidated: handleValidation
          }, null, 8, ["modelValue", "label"]),
          _createVNode(FormInput, {
            modelValue: name.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
            ref: addFormInputRef,
            label: _unref(t)('products.form.accountingSoftwareConfiguration.accountCodeName'),
            name: "new-account-code-name",
            type: "text",
            onValidated: handleValidation
          }, null, 8, ["modelValue", "label"]),
          (errorMessage.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(errorMessage.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", _hoisted_9, _toDisplayString(_unref(t)('global.add')), 1),
            _createElementVNode("button", {
              class: "btn btn--fullscreen btn--red",
              type: "button",
              onClick: closePopup
            }, _toDisplayString(_unref(t)('global.cancel')), 1)
          ])
        ])
      ])
    ])
  ], 40, _hoisted_1))
}
}

})